import { useTranslation } from 'react-i18next';
import VibrationModal from '../../modals/VibrationModal';
import { CHAT_URL } from '../../../config';


interface PlotTakenModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PlotTakenModal({ isOpen, onClose }: PlotTakenModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <VibrationModal
      isOpen={isOpen}
      onClose={onClose}
      variant="dialog"
      className="max-w-[372px] rounded-xl bg-white p-0"
      hideHeader={true}
      closeOnBackdropClick={true}
    >
      <div className="relative max-h-[90vh] w-full overflow-hidden overflow-y-auto rounded-xl bg-white">
        <div
          className="plot-taken-modal-content mx-auto box-border flex w-full max-w-[332px] flex-col items-center gap-xl px-2xl py-4xl max-[360px]:gap-lg max-[360px]:px-lg max-[360px]:py-xl"
        >
          {/* Заголовок та текст */}
          <div className="flex w-full flex-col items-center justify-center gap-sm text-center">
            <h2
              className="plot-taken-modal-title m-0 [font-family:'Rubik_One',sans-serif] text-[18px] leading-[30px] font-normal tracking-[0px] text-text-dark max-[360px]:text-[16px] max-[360px]:leading-[24px]"
            >
              {t("Failure")}
            </h2>
            <p
              className="plot-taken-modal-text m-0 whitespace-pre-wrap [font-family:Lato,sans-serif] text-[16px] leading-[20px] font-normal tracking-[0px] text-text-dark max-[360px]:text-[14px] max-[360px]:leading-[18px]"
            >
              {t("Sorry, unfortunately you didn't make it in time. There are no free plots left on the map right now. Keep following the free-plot announcements in the official game chat to be the first:")}
              {' '}
              <a
                href={CHAT_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="font-semibold text-action-end underline"
              >
                {t("official game chat")}
              </a>
            </p>
          </div>

          {/* Зображення та кнопка */}
          <div className="flex w-full flex-1 flex-col items-center justify-between gap-3xl">
            {/* Зображення ділянки */}
            <div
              className="plot-taken-modal-image relative aspect-square w-full max-w-[269.479px] max-[360px]:max-w-[200px]"
            >
              <div className="relative z-[1] h-full w-full">
                <img
                  src="/ui/world-map/plot-is-free-image.png"
                  alt="Plot taken"
                  className="block h-full w-full object-cover object-center [filter:grayscale(60%)_opacity(0.75)]"
                />
              </div>
            </div>

            {/* Кнопка OK */}
            <button
              className="plot-taken-modal-button mt-auto box-border w-full cursor-pointer rounded-pill border-none bg-[image:var(--gradient-action-primary)] px-2xl py-lg text-center [font-family:'Rubik_One',sans-serif] text-[16px] leading-[24px] font-normal tracking-[0px] text-white shadow-action-raised [transition:all_0.2s_ease] max-[360px]:px-xl max-[360px]:py-[10px] max-[360px]:text-[14px]"
              onClick={onClose}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.9';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
            >
              {t("OK")}
            </button>
          </div>
        </div>
      </div>
    </VibrationModal>
  );
}
